import React from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { SEOHead } from '../components/ui/SEOHead'
import { TerminalWindow } from '../components/terminal/TerminalWindow'

const REASON_MESSAGES: Record<string, string> = {
  'invalid-token': 'The link has expired or is invalid. Please subscribe again.',
  'server-error' : 'An internal error occurred. Please try again later.',
}

export const SubscribeErrorPage: React.FC = () => {
  const [params] = useSearchParams()
  const reason   = params.get('reason') ?? 'unknown'
  const message  = REASON_MESSAGES[reason] ?? 'Something went wrong.'

  return (
    <>
      <SEOHead title="Subscription Error" />
      <TerminalWindow title="error.sh">
        <div
          style={{
            fontFamily: "'JetBrains Mono', 'Courier New', monospace",
            fontSize: '0.9rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
          }}
        >
          <div style={{ color: 'var(--accent-red)' }}>
            Error: {message}
          </div>
          <Link to="/" style={{ color: 'var(--accent-blue)', fontSize: '0.85rem' }}>
            [← back to home]
          </Link>
        </div>
      </TerminalWindow>
    </>
  )
}
